import React, {useState} from 'react';
import './index.css';

const ImageMagnifier = ({imageSrc, altText = 'picture'}) => {
  const [isMagnified, setIsMagnified] = useState(false);

  const toggleMagnify = () => {
    setIsMagnified(!isMagnified);
  };

  return (
    <div
      className={`magnifier-container ${isMagnified ? 'center-screen' : ''}`}
    >
      <div
        className={`image-container ${isMagnified ? 'magnified' : ''}`}
        onClick={isMagnified ? toggleMagnify : null}
      >
        <img src={imageSrc} alt={altText} className="magnifier-image" />
        {!isMagnified && (
          <button className="magnifier-button" onClick={toggleMagnify}>
            <i className="fa fa-search-plus" />
          </button>
        )}
        {isMagnified && (
          <button className="zoom-out-button" onClick={toggleMagnify}>
            <i className="fa fa-search-minus" />
          </button>
        )}
      </div>
    </div>
  );
};

export default ImageMagnifier;
